





























































































































































import Vue from 'vue';
import BeeswarmLoader from '@/components/UI/Loader/BeeswarmLoader.vue';
import HeaderLoader from '@/components/UI/Loader/HeaderLoader.vue';
import DatePickerCondensed from '@/components/UI/DatePickerCondensed.vue';
import SessionFilter from '@/components/CancelAnalytics/SessionFilter.vue';
import SessionFeedbackTooltip from '@/components/CancelAnalytics/SessionFeedbackTooltip.vue';
import FeedbackCard from '@/components/CancelAnalytics/FeedbackCard.vue';
import { timeDay } from 'd3-time';
import { getDateEndpoints } from '@/helpers/date-utils';
import { LOAD_STATE } from '@/store/shared';
import statsService from '@/api/stats.service';
import { ISentimentSession } from '@/store/types';
import { mapGetters } from 'vuex';
import * as d3 from 'd3';
import { clamp } from '@/helpers/jsUtils';
import { descending } from 'd3';
import { ascending } from 'vega';
import { Beeswarm, IDatum, ISimulationNodeDatum } from '../Vis/D3/Charts/Beeswarm';
import BeeswarmWrapper from '../Vis/D3/Charts/BeeswarmWrapper.vue';
import { EXPORT_DATA } from '../../store/action-types';

const SessionFeedbackTooltipConstructor = Vue.extend(SessionFeedbackTooltip);

const features = [
  {
    key: 'sentiment',
    label: 'Testimonial-Worthy Feedback',
    shortLabel: 'Testimonial',
    description: 'Customers who love your product.',
    thresholds: [0.8, 1, 1.2],
    currentThreshold: 1,
    enabled: true,
    icon: 'medal',
    iconColor: 'text-green-600',
    iconBg: 'text-green-100',
    bgColor: 'bg-green-100',
  },

  {
    key: 'feature',
    label: 'Product Suggestions',
    shortLabel: 'Product Suggestion',
    description: 'Customer input that focuses on product features.',
    thresholds: [0.5, 0.6, 0.7],
    currentThreshold: 0.6,
    enabled: true,
    icon: 'comment-dots',
    iconColor: 'text-brand-blue',
    iconBg: 'text-brand-medium-blue',
    bgColor: 'bg-brand-medium-blue',
  },
  {
    key: 'refund',
    label: 'Refund Requests',
    shortLabel: 'Refund Request',
    description: 'Feedback that might be requesting a refund.',
    thresholds: [0.8, 0.85, 0.9],
    currentThreshold: 0.85,
    enabled: true,
    icon: 'comment-dollar',
    iconColor: 'text-fuschia-600',
    iconBg: 'text-fuschia-100',
    bgColor: 'bg-fuschia-100',
  },
];

const colorScale = d3
  .scaleLinear<string>()
  .domain([0, 0.33, 0.67, 1])
  .range(['#FF6263', '#E64196', '#AA35E3', '#7047FF'].reverse())
  // .domain([0, 0.25, 0.5, 0.75, 1])
  // .range(['#FCDA7D', '#F48231', '#C54072', '#98399C', '#4C62D5'].reverse())
  .clamp(true);

const limit = 500;

// const colorScale = d3
//   .scaleLinear<string>()
//   .domain([-0.5, -0.01, -1e-8, 1e-8, 0.01, 0.5])
//   .range(['#CB3066', '#df7eac', '#9D52B2aa', '#9D52B2aa', '#aD9Afa', '#3f2b96'].reverse())
//   .clamp(true);

export default Vue.extend({
  name: 'FeedbackLab',
  components: {
    HeaderLoader,
    BeeswarmLoader,
    DatePickerCondensed,
    SessionFilter,
    BeeswarmWrapper,
    FeedbackCard,
  },
  data() {
    const defaultStartDate = timeDay.offset(new Date(), -90);
    const [startDate, endDate] = getDateEndpoints([defaultStartDate, new Date()]);
    return {
      startDate,
      endDate,
      features,
      limit,
      filter: {} as Record<string, string[]>,
      initialLoading: true,
      sessionFeedback: [] as ISentimentSession[],
      dataLoadState: LOAD_STATE.UNLOADED,
      chartLoading: true,
      focalSessionId: null as null | string,
      recentFeedback: [] as ISentimentSession[],
    };
  },
  async created() {
    await this.fetchData();
    await this.fetchRecentData();
    // if (this.sessionFeedback.length < 8 && this.daysSinceOrgCreated && this.daysSinceOrgCreated > 90) {
    //   this.startDate = this.orgCreatedDate;
    //   await this.fetchData();
    // }
    this.initialLoading = false;
  },
  computed: {
    ...mapGetters(['daysSinceOrgCreated', 'orgCreatedDate', 'waitForData', 'confidential']),
    statsLoading(): boolean {
      return this.dataLoadState !== LOAD_STATE.LOADED;
    },
    chartConfigs(): any {
      return this.features
        .filter((f) => f.enabled)
        .map((f) => {
          const allMatches = this.sessionFeedback.filter(
            // @ts-ignore
            (s) => s.eScores[f.key] && s.eScores[f.key] > f.thresholds[0]
          );
          const currentMatches = this.sessionFeedback.filter(
            // @ts-ignore
            (s) => s.eScores[f.key] && s.eScores[f.key] > f.currentThreshold
          );
          const hiddenCount = allMatches.length - currentMatches.length;
          const size = clamp(10 - Math.sqrt(currentMatches.length) / 5, 4.5, 9.5);
          return {
            size,
            hiddenCount,
            onLowestThreshold: f.currentThreshold === f.thresholds[0],
            noData: currentMatches.length === 0,
            data: currentMatches,
            min: f.currentThreshold,
            // @ts-ignore
            valueAccessor: (d: ISentimentSession) => d.eScores[f.key],
            ...f,
          };
        });
    },
    featuredFeedbackGroups(): any {
      return this.features
        .filter((f) => f.enabled)
        .map((f) => {
          const relevantFeedback = this.recentFeedback.filter(
            // @ts-ignore
            (s) => s.eScores[f.key] && s.eScores[f.key] > f.thresholds[0]
          );

          // Calculate a hybrid score for each feedback
          relevantFeedback.forEach((s) => {
            const daysSince = (new Date().getTime() - new Date(s.createdAt).getTime()) / (1000 * 60 * 60 * 24);

            // This formula gives weight to both eScore and recency.
            // @ts-ignore
            s.hybridScore = 2 * s.eScores[f.key] + 0.5 * (1 / (daysSince / 7 + 1)); // Adding 1 to denominator to avoid division by zero
          });

          // Sort feedbacks based on the hybrid score
          //@ts-ignore
          relevantFeedback.sort((a, b) => descending(a.hybridScore, b.hybridScore));

          return {
            feature: f,
            sessions: relevantFeedback.slice(0, 5),
          };
        })
        .filter((f) => f.sessions.length > 0);
    },
  },
  methods: {
    onFilterUpdate(newFilter: Record<string, string[]>) {
      this.filter = newFilter;
      this.fetchData();
    },
    exportFeedback() {
      const dataToExport = this.sessionFeedback.map((s) => ({
        email: s.customer?.email,
        date: s.createdAt,
        plan: s.customer?.planId,
        feedback: s.feedback,
        surveyResponse: s.surveyChoiceValue,
        featureScore: s.eScores.feature,
        testimonialScore: s.eScores.grateful,
        refundScore: s.eScores.refund,
        sentimentScore: s.eScores.sentiment,
        billingInterval: s.customer?.billingInterval,
      }));
      this.$store.dispatch(EXPORT_DATA, {
        // @ts-ignore
        data: dataToExport,
        name: 'session-feedback',
        fields: [
          'email',
          'date',
          'plan',
          'feedback',
          'surveyResponse',
          'featureScore',
          'testimonialScore',
          'refundScore',
          'sentimentScore',
          'billingInterval',
        ],
        csv: true,
      });
    },
    async fetchData() {
      const mappedFilter = Object.keys(this.filter).reduce(
        (acc, k) => {
          if (this.filter[k].length === 1) {
            acc[k] = this.filter[k][0];
          }
          return acc;
        },
        {} as Record<string, any>
      );
      mappedFilter.startDate = this.startDate;
      mappedFilter.endDate = this.endDate;
      try {
        this.dataLoadState = LOAD_STATE.LOADING;
        const stats = await statsService.filteredFeedback({
          filter: mappedFilter,
          options: { skip: 0, limit },
        });

        this.sessionFeedback = stats.map((d) => ({
          ...d,
          id: d._id,
        }));
        this.dataLoadState = LOAD_STATE.LOADED;
      } catch (e) {
        console.log(e);
        this.dataLoadState = LOAD_STATE.ERROR_LOADING;
      }
    },
    async fetchRecentData() {
      const startDate = timeDay.offset(new Date(), -30);
      const endDate = new Date();
      const stats = await statsService.filteredFeedback({
        filter: { startDate, endDate },
        options: { skip: 0, limit: 100 },
      });
      this.recentFeedback = stats.map((d) => ({
        ...d,
        id: d._id,
      }));
    },
    decreaseThreshold(key: string) {
      const feature = this.features.find((f) => f.key === key);
      if (feature) {
        feature.currentThreshold = feature.thresholds[Math.max(0, feature.thresholds.indexOf(feature.currentThreshold) - 1)];
      }
    },
    resetThreshold(key: string) {
      const feature = this.features.find((f) => f.key === key);
      if (feature) {
        feature.currentThreshold = feature.thresholds[feature.thresholds.length - 1];
      }
    },
    handleDateChange(value: [Date, Date]) {
      this.startDate = value[0];
      this.endDate = value[1];
      this.fetchData();
    },
    handleDraw() {
      this.chartLoading = false;
    },
    handleNodeClick(d: ISimulationNodeDatum, chart: Beeswarm) {
      // @ts-ignore
      const path = `/customer/${d.customer.id}`;
      chart.tooltip.remove();
      this.$router.push(path);
      // @ts-ignore
      // window.open(`/customer/${d.customer.id}`, '_blank');
      // if (d.id === this.focalSessionId) {
      //   this.focalSessionId = null;
      // } else {
      //   this.focalSessionId = d.id;
      // }
    },
    getNodeTooltip(metric: any): (tooltip: d3.Selection<HTMLDivElement, any, any, any>, node: IDatum, chart: Beeswarm) => void {
      return (tooltip: d3.Selection<HTMLDivElement, any, any, any>, node: IDatum, chart: Beeswarm) => {
        tooltip.html('');
        tooltip.style('min-width', '350px');
        tooltip.append('div').attr('id', 'nlp-tooltip');
        // @ts-ignore
        const confidential = this.confidential;
        const vm = new SessionFeedbackTooltipConstructor({
          propsData: {
            session: node,
            confidential,
          },
        }).$mount('#nlp-tooltip');
      };
    },
    mainColor(d: IDatum, beeswarm: Beeswarm) {
      const focalNode = beeswarm.focalNode;
      const [minValue, maxValue] = beeswarm.xScale.domain();
      return colorScale(beeswarm.normalizeScale(beeswarm.valueAccessor(d)));
    },
  },
});
